import { Container, type interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { baseModule } from '@/container-modules/base-module';
import { headerServiceModule } from '@/container-modules/header-service-module';
import { trackModule } from './container-modules/track-module';
import { reportModule } from './container-modules/page-module';
import { projectCopilotModule } from './container-modules/project-copilot-module';
import { biTrackModule } from '@eureka/domains';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    headerServiceModule,
    trackModule,
    reportModule,
    projectCopilotModule,
    biTrackModule
);

export function rebind(serviceIdentifier: interfaces.ServiceIdentifier<unknown>) {
    if (container.isBound(serviceIdentifier)) {
        container.unbind(serviceIdentifier);
    }
    return container.bind(serviceIdentifier);
}

export {
    container,
};
